import { buildSkippedRowsSheet } from "../engine/skippedRowsSheet";
import { isJoinSkippedRow, SkippedRow, WorksheetRows } from "../engine/validationTypes";

const ROW_NUMBER_COLUMN = "Row";

// Excel's limit on a tab name
const MAX_TAB_NAME_LENGTH = 31;

// One tab per worksheet listing the later-sheet rows the join left out, as the joined rows don't hold them.
// Rows are written one after another under a first-row header; the Row column keeps each row's number on its own sheet.
export function buildJoinLeftOutSheets(skippedRowsByWorksheet: Map<string, SkippedRow[]>): WorksheetRows[] {
  return [...skippedRowsByWorksheet].flatMap(([worksheet, skippedRows]) => {
    const sheet = buildSkippedRowsSheet(worksheet, skippedRows.filter(isJoinSkippedRow));
    if (!sheet) return [];
    const columns = Object.keys(sheet.columns);
    return [
      {
        worksheet: `Left out - ${worksheet}`.slice(0, MAX_TAB_NAME_LENGTH),
        sourceColumns: [ROW_NUMBER_COLUMN, ...columns],
        rows: sheet.rowNumbers.map((rowNumber, index) => [
          String(rowNumber),
          ...columns.map((column) => sheet.columns[column][index]),
        ]),
        rowNumbers: sheet.rowNumbers.map((_, index) => index + 2),
      },
    ];
  });
}
